export default __webpack_public_path__ + "static/media/fad-digital-dot.7177f8b3.svg";